@use "styles/abstracts/mixins/common" as c;
@use "styles/abstracts/variables" as v;

.editTagsPopup {
  width: 600px;

  @include c.containerMedia(v.$tablet-breakpoint) {
    width: calc(100% - 30px);
  }
}